module.exports = __webpack_public_path__ + "img/simple_clock_icon.06cca0cd.svg";